import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import AddChildren from "../../../components/AddChildren/AddChildren";
import { getChilds } from "../../../redux/actions/child";


const Child = () => {
  const [ready, setReady] =useState(false);
  const [open, setOpen] =useState(false);
  const [list, setList] =useState([]);

  const dispatch= useDispatch();

  const initFunc=()=>{
    // setList([{id:'1',lastName:'lastName', firstName:'firstName', documentNumber:'1234567890', birthday:'12.01.2020', isVpo:false, isInvo:false},{id:'2',lastName:'lastName', firstName:'firstName',documentNumber:'1234567890', birthday:'12.01.2020', isVpo:true, isInvo:true}])
    dispatch(getChilds({})).then(res=>{
      setList(res);
    })

  }

  const addNewChild =()=>{
    setOpen(true);
  }
  
  useEffect(() => {
    if(!ready){
      initFunc();
    }

  }, [ready]);



  return(
    <>
          <div className="childRow">
                <div className="childItem addNew" onClick={addNewChild}>
                  <span>+</span>
                  Додати нову дитину
                </div>
          {list?.length>0 && list?.map((el, index) => {
              return (
                <div key={index} className="childItem">
                  <div className="childItemValue">
                    {el.lastName} {el.firstName}
                  </div>
                  <div
                    className="childItemValue"
                  >
                    {el.documentNumber}
                  </div>
                  <div className="childItemValue">
                    {el.birthday}
                  </div>
                  <div className="childItemValue childItemValueRight">
                    {el.isVpo && "ВПО "}
                    {el.isInvo && "Інвалід"}
                  </div>
                </div>
              );
            })
            // <div className="apEmptyCategory">У вас не додано жодної дитини</div>
            }
        </div>
        {open && <AddChildren></AddChildren>}
    </>
  )

};

export default Child;
